import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-339a51b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "SeesawImageContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/34593a80-f3d0-e552-282f-e3da8586a11c.jpg",
  style: {
    "width": "200px",
    "object-position": "top"
  }
}, null, -1));
const _hoisted_3 = {
  key: 0,
  src: "https://cdn.waityou.online/47c28d60-2067-7e6e-aa02-1592af845d3f.jpg",
  style: {
    "width": "200px"
  }
};
const _hoisted_4 = {
  key: 0,
  src: "https://cdn.waityou.online/36721866-6d32-dfb8-e848-7e8b8d7fd937.jpg",
  style: {
    "width": "200px"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "无法判断", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SeesawLoad = _resolveComponent("SeesawLoad");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.flag == '<' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    style: {
      "width": "200px"
    },
    class: "flex flex-col"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col",
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.left, (l, li) => {
          return _openBlock(), _createBlock(_component_SeesawLoad, {
            key: `left_${li}`,
            data: l
          }, null, 8, ["data"]);
        }), 128))]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col items-end",
        style: {
          "justify-content": "flex-end",
          "margin-bottom": "-50px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.right, (r, ri) => {
          return _openBlock(), _createBlock(_component_SeesawLoad, {
            key: `right_${ri}`,
            data: r
          }, null, 8, ["data"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    }), _hoisted_2]),
    _: 1
  })) : $data.flag == '>' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    style: {
      "width": "200px"
    },
    class: "flex flex-col"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col",
        style: {
          "justify-content": "flex-end",
          "margin-bottom": "-50px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.left, (l, li) => {
          return _openBlock(), _createBlock(_component_SeesawLoad, {
            key: `left_${li}`,
            data: l
          }, null, 8, ["data"]);
        }), 128))]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col items-end",
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.right, (r, ri) => {
          return _openBlock(), _createBlock(_component_SeesawLoad, {
            key: `right_${ri}`,
            data: r
          }, null, 8, ["data"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    }), $data.flag == '>' ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)]),
    _: 1
  })) : $data.flag == '=' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    style: {
      "width": "200px"
    },
    class: "flex flex-col"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      style: {
        "margin-bottom": "-30px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col",
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.left, (l, li) => {
          return _openBlock(), _createBlock(_component_SeesawLoad, {
            key: `left_${li}`,
            data: l
          }, null, 8, ["data"]);
        }), 128))]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col items-end",
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.right, (r, ri) => {
          return _openBlock(), _createBlock(_component_SeesawLoad, {
            key: `right_${ri}`,
            data: r
          }, null, 8, ["data"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    }), $data.flag == '=' ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    style: {
      "width": "200px"
    },
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }))]);
}